import { ArrowRight, Zap, Shield, Rocket, Target, Mail, Building2 } from "lucide-react";
import { useState, useEffect } from "react";
import { useFlexOfficeCTA } from "./useFlexOfficeCTA";
import data from "../data/flexOfficeData.json";

const ICON_MAP = { Zap, Shield, Rocket, Target };

const useBreakpoint = () => {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return { isMobile: w < 640, isTablet: w >= 640 && w < 1024 };
};

const FlexOfficeCTA = () => {
  const cta = useFlexOfficeCTA();
  const { isMobile, isTablet } = useBreakpoint();
  const d = data.cta;

  return (
    <section style={{ background: "#f8fafc", padding: isMobile ? "60px 20px" : isTablet ? "72px 32px" : "96px 40px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ background: "linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%)", borderRadius: 28, padding: isMobile ? "48px 24px" : isTablet ? "56px 40px" : "72px 56px", textAlign: "center", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -80, right: -80, width: 320, height: 320, borderRadius: "50%", background: "rgba(255,255,255,0.06)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -60, left: -60, width: 240, height: 240, borderRadius: "50%", background: "rgba(255,255,255,0.04)", pointerEvents: "none" }} />
          <div style={{ position: "relative" }}>
            <div style={{ width: 64, height: 64, background: "rgba(255,255,255,0.15)", borderRadius: 18, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px" }}>
              <Building2 style={{ width: 32, height: 32, color: "white" }} />
            </div>
            <h2 style={{ fontSize: isMobile ? 26 : isTablet ? 34 : 46, fontWeight: 900, color: "white", letterSpacing: "-0.02em", lineHeight: 1.1, marginBottom: 16 }}>{d.headline}</h2>
            <p style={{ fontSize: isMobile ? 14 : 18, color: "rgba(255,255,255,0.7)", maxWidth: 560, margin: "0 auto 36px", lineHeight: 1.7 }}>{d.description}</p>

            {/* Highlights grid */}
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)", gap: isMobile ? 10 : 16, maxWidth: 720, margin: "0 auto 40px" }}>
              {d.highlights.map((h, i) => {
                const IconComp = ICON_MAP[h.icon];
                return (
                  <div key={i} style={{ background: "rgba(255,255,255,0.1)", borderRadius: 14, padding: isMobile ? "14px 10px" : "18px 16px", textAlign: "center" }}>
                    <div style={{ color: "rgba(255,255,255,0.85)", marginBottom: 8, display: "flex", justifyContent: "center" }}>
                      {IconComp && <IconComp style={{ width: 18, height: 18 }} />}
                    </div>
                    <div style={{ color: "white", fontSize: isMobile ? 12 : 13, fontWeight: 600, lineHeight: 1.4 }}>{h.text}</div>
                  </div>
                );
              })}
            </div>

            <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
              {/* ── Get Started Free ── */}
              <button
                onClick={cta.getStarted}
                style={{ padding: isMobile ? "13px 28px" : "15px 36px", borderRadius: 12, fontSize: isMobile ? 14 : 15, fontWeight: 700, background: "white", color: "#1d4ed8", border: "none", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 10, transition: "all 0.25s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "none"}>
                {d.buttons[0].label} <ArrowRight style={{ width: 17, height: 17 }} />
              </button>

              {/* ── Request Demo ── */}
              <button
                onClick={cta.bookDemo}
                style={{ padding: isMobile ? "13px 28px" : "15px 36px", borderRadius: 12, fontSize: isMobile ? 14 : 15, fontWeight: 700, background: "transparent", color: "white", border: "2px solid rgba(255,255,255,0.35)", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 10, transition: "all 0.25s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(255,255,255,0.7)"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)"}>
                <Mail style={{ width: 16, height: 16 }} /> {d.buttons[1].label}
              </button>
            </div>

            <div style={{ display: "flex", gap: isMobile ? 14 : 28, justifyContent: "center", marginTop: 28, flexWrap: "wrap" }}>
              {d.trustPoints.map((t, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 7, height: 7, borderRadius: "50%", background: t.color }} />
                  <span style={{ color: "rgba(255,255,255,0.6)", fontSize: isMobile ? 12 : 14 }}>{t.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexOfficeCTA;
